import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/app/')({
  component: RouteComponent,
  beforeLoad: async () => {
    throw redirect({
      to: '/app/requests',
    })
  },
})
function RouteComponent() {
  return null
}
